import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Types for search results coming from TMDB (minimal shape used in the UI)
export type TmdbItem = {
  id: number | string;
  title?: string;
  name?: string;
  poster_path?: string | null;
  release_date?: string | null;
  first_air_date?: string | null;
  [key: string]: any;
};

export type CurrentSearch = {
  keywords: string;
  movies: TmdbItem[];
  series: TmdbItem[];
};

type SearchState = {
  nameSearch: string;
  setNameSearch: (value: string) => void;
  currentSearch: CurrentSearch;
  setCurrentSearch: (value: CurrentSearch) => void;
  clearCurrentSearch: () => void;
  loading: boolean;
  setLoading: (v: boolean) => void;
  hoveringOver: TmdbItem | null;
  setHoveringOver: (item: TmdbItem | null) => void;
  reset: () => void;
};

const DEFAULT_SEARCH: CurrentSearch = {
  keywords: '',
  movies: [],
  series: []
};

// Persist the store to localStorage under the key 'cap17drive-search'
export const useSearchStore = create<SearchState>()(
  persist<SearchState>(
    (set, get) => ({
      nameSearch: '',
      setNameSearch: (value: string) => {
        set({ nameSearch: value });
      },
      currentSearch: DEFAULT_SEARCH,
      setCurrentSearch: (value: CurrentSearch) => set({ currentSearch: value }),
      clearCurrentSearch: () => set({ currentSearch: DEFAULT_SEARCH }),
      loading: false,
      setLoading: (v: boolean) => set({ loading: v }),
      hoveringOver: null,
      setHoveringOver: (item: TmdbItem | null) => set({ hoveringOver: item }),
      reset: () => set({ nameSearch: '', currentSearch: DEFAULT_SEARCH, loading: false, hoveringOver: null })
    }),
    ({
      name: 'cap17drive-search',
      partialize: (state: SearchState) => ({ nameSearch: state.nameSearch, currentSearch: state.currentSearch })
    } as any)
  )
);

export default useSearchStore;
